import PrimaryModal from '../UI/Modal/PrimaryModal';
import { ErrorButton, SecondaryButton } from "../UI";
import { toast } from 'react-toastify';
import { useState } from 'react';
import { useUserContext } from '../../contexts/UserContext';
import { deleteOrganizationUserInvitaion } from '../../utils/APIs';
import { useContentfulContext } from '../../contexts/ContentfulContext';

const InvokeInvitationModal = ({ CloseModal, invitationId, refreshData }) => {
    const { content } = useContentfulContext()
    const [loading, setLoading] = useState(false);
    const { userData } = useUserContext();

    const handleDelete = async () => {
        setLoading(true);
        try {
            const res = await deleteOrganizationUserInvitaion(userData?.token, userData?.selectedOrganization?.org_token, invitationId);
            if (res.status) {
                toast.success(res.message || 'Invitation deleted successfully.');
                await refreshData(); // refetch updated invitations
                CloseModal();
            }
        } catch (error) {
            console.log(error?.response)
            const errorMessage = error?.response?.data?.message || 'Failed to delete invitation.';
            toast.error(errorMessage);
            console.error('Delete invitation error:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <PrimaryModal
            title="Revoke Invitation"
            hideModal={() => CloseModal()}
        >
            <div className="p-6 space-y-6">
                <p>{content.MANAGE_USERS.deleteText}</p>
                <div className="flex justify-end space-x-4">
                    <ErrorButton handleClick={handleDelete} disabled={loading}>
                        {loading ? 'Revoking...' : 'Revoke'}
                    </ErrorButton>
                    <SecondaryButton handleClick={() => CloseModal()}>
                        {content.MANAGE_USERS.cancel}
                    </SecondaryButton>
                </div>
            </div>
        </PrimaryModal>
    );
};

export default InvokeInvitationModal;
